import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SaveSlackIntegrationCommandClass;
function SaveSlackIntegrationCommand() {
  if (SaveSlackIntegrationCommandClass === VOID) {
    class $ {
      constructor(partyId, channel, team) {
        this.q2k_1 = partyId;
        this.r2k_1 = channel;
        this.s2k_1 = team;
      }
      t2k(partyId, channel, team) {
        return new (SaveSlackIntegrationCommand())(partyId, channel, team);
      }
      u2k(partyId, channel, team, $super) {
        partyId = partyId === VOID ? this.q2k_1 : partyId;
        channel = channel === VOID ? this.r2k_1 : channel;
        team = team === VOID ? this.s2k_1 : team;
        return $super === VOID ? this.t2k(partyId, channel, team) : $super.t2k.call(this, partyId, channel, team);
      }
      toString() {
        return 'SaveSlackIntegrationCommand(partyId=' + this.q2k_1.toString() + ', channel=' + this.r2k_1 + ', team=' + this.s2k_1 + ')';
      }
      hashCode() {
        var result = this.q2k_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.r2k_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s2k_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationCommand()))
          return false;
        if (!this.q2k_1.equals(other.q2k_1))
          return false;
        if (!(this.r2k_1 === other.r2k_1))
          return false;
        if (!(this.s2k_1 === other.s2k_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationCommand');
    SaveSlackIntegrationCommandClass = $;
  }
  return SaveSlackIntegrationCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher3kdydho2ojhnk,
  SaveSlackIntegrationCommand as SaveSlackIntegrationCommand3vduj8nfpy1wd,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationCommand.mjs.map
